import { MouseEvent } from 'react';
import { Stack } from '@common-components';
import { ViewStream as ViewStreamIcon } from '@icons';
import { messages } from 'i18n';
import IconBadge from 'components/IconBadge';

interface PlacementProcessIconButtonProps {
  onClick?: (e: MouseEvent) => void;
  bgColor?: string;
}

export function PlacementProcessButton({ onClick, bgColor }: PlacementProcessIconButtonProps) {
  const handleClick = (e: MouseEvent) => {
    onClick?.(e);
  };

  return (
    <Stack onClick={handleClick}>
      <IconBadge
        sx={{
          minWidth: 30,
          cursor: 'pointer',
        }}
        tooltipContent={messages.placementProcess.iconButton.tooltip}
        inheritColorTooltip
        IconComponent={ViewStreamIcon}
        bgcolor={bgColor ?? 'transparent'}
        size="small"
      />
    </Stack>
  );
}
